import React from "react";

const Password = () => {
  return (
    <div className="text-black font-bold p-5 underline font-serif">
      Your one-time password has been sent to your e-mail.
    </div>
  );
};

export default Password;
